angular.module('NaviaqWebApp').directive('activityLineDate', [function () {
    'use strict';

    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'app/report/directives/activity-line-date.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
